import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { selectCase } from "redux/slices/case";
import { selectForm } from "redux/slices/form.slice";
import IntakesReview from "../intakes/IntakesReview";
import { createPortal } from "react-dom";
import { CaseDetailGroup } from "components/CaseDetailGroup";
import { PortalContext } from "contexts/PortalContext";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";

const Review = () => {
  // Route is /lens/:lensId/case/:caseId/review
  // Get lensId and caseId from the route with useParams
  const navigate = useNavigate();
  const { caseId, lensId } = useParamNumbers(["caseId", "lensId"]);
  const clientCase = useAppSelector(selectCase);
  const { portalRefElement } = useContext(PortalContext);

  if (lensId === undefined || caseId === undefined) {
    navigate("/lens");
    return null;
  }

  const form = useAppSelector(selectForm);
  const lensCase = useAppSelector(selectCase);

  return (
    <>
      {portalRefElement && createPortal(<CaseDetailGroup myCase={clientCase} />, portalRefElement)}
      {form !== undefined && lensCase !== undefined && (
        <div className="min-h-0 h-full pt-2">
          <IntakesReview lensId={lensId} caseId={caseId} form={form} mycase={lensCase} />
        </div>
      )}
    </>
  );
};

export default Review;
